<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <h3 class="px-3">Project Structure</h3>
                            </div>
                        </div>
                    </div> 
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-12 d-flex">
                            <nav>
                                <div class="nav nav-tabs mb-2" id="nav-tab">
                                    <a class="nav-item nav-link active p-2" id="nav-home-tab" data-toggle="tab" href="#nav-region"> <h3>Region</h3> </a>
                                    <a class="nav-item nav-link p-2" id="nav-industry-tab" data-toggle="tab" href="#nav-industry"> <h3>Industry</h3> </a>
                                    <a class="nav-item nav-link p-2" id="nav-businessGroup-tab" data-toggle="tab" href="#nav-businessGroup"> <h3>Business Group</h3> </a>
                                    <a class="nav-item nav-link p-2" id="nav-commodity-tab" data-toggle="tab" href="#nav-commodity"> <h3>Commodity</h3> </a>
                                    <span class="nav-separator"></span>
                                    <a class="nav-item nav-link p-2" id="nav-activity-tab" data-toggle="tab" href="#nav-activity"> <h3>Activity</h3> </a>
                                    <a class="nav-item nav-link p-2" id="nav-projectSoftware-tab" data-toggle="tab" href="#nav-projectSoftware"> <h3>Project Software</h3> </a>
                                    <a class="nav-item nav-link p-2" id="nav-task-tab" data-toggle="tab" href="#nav-task"> <h3>Task</h3> </a>
                                </div>
                            </nav>
                        </div>
                    </div>

                    <div class="canvas-data">
                        <div class="tab-content pt-2" id="nav-tabContent">
                            <div class="tab-pane fade show active" id="nav-region" role="tabpanel">
                                <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                    <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                        <button type="button" (click)="editOpenRegionModal()" data-bs-toggle="modal" data-bs-target="#regionModal">
                                        <span><i class="ri-pencil-line"></i></span>
                                        </button>
                                    </div>
                                    <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                        <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('region')">
                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                        </button>
                                    </div>
                                    <button type="button" (click)="createOpenRegionModal()" data-bs-toggle="modal" data-bs-target="#regionModal" class="btn btn-icon">
                                        <i class="ri-add-line"></i>
                                    </button>
                                </div>
        
                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material grid"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData1"
                                    [columnDefs]="columnDefs1"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>

                            <div class="tab-pane fade" id="nav-industry" role="tabpanel">
                                <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                    <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" (click)="editOpenIndustryModal()" data-bs-toggle="modal" data-bs-target="#industryModal">
                                        <span><i class="ri-pencil-line"></i></span>
                                      </button>
                                    </div>
                                    <div class="delete" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('industry')">
                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                      </button>
                                    </div>
                                    <button type="button" (click)="createOpenIndustryModal()" data-bs-toggle="modal" data-bs-target="#industryModal" class="btn btn-icon">
                                      <i class="ri-add-line"></i>
                                    </button>
                                </div>

                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData2"
                                    [columnDefs]="columnDefs2"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>

                            <div class="tab-pane fade" id="nav-businessGroup" role="tabpanel">
                                <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                    <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" (click)="editOpenBusinessGroupModal()" data-bs-toggle="modal" data-bs-target="#businessGroupModal">
                                        <span><i class="ri-pencil-line"></i></span>
                                      </button>
                                    </div>
                                    <div class="delete" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('businessGroup')">
                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                      </button>
                                    </div>
                                    <button type="button" (click)="createOpenBusinessGroupModal()" data-bs-toggle="modal" data-bs-target="#businessGroupModal" class="btn btn-icon">
                                      <i class="ri-add-line"></i>
                                    </button>
                                </div>

                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData3"
                                    [columnDefs]="columnDefs3"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>

                            <div class="tab-pane fade" id="nav-commodity" role="tabpanel">
                                <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                    <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" (click)="editOpenCommodityModal()" data-bs-toggle="modal" data-bs-target="#commodityModal">
                                        <span><i class="ri-pencil-line"></i></span>
                                      </button>
                                    </div>
                                    <div class="delete" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('commodity')">
                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                      </button>
                                    </div>
                                    <button type="button" (click)="createOpenCommodityModal()" data-bs-toggle="modal" data-bs-target="#commodityModal" class="btn btn-icon">
                                      <i class="ri-add-line"></i>
                                    </button>
                                </div>

                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData4"
                                    [columnDefs]="columnDefs4"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>

                            <div class="tab-pane fade" id="nav-activity" role="tabpanel">
                                <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                    <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" (click)="editOpenActivityModal()" data-bs-toggle="modal" data-bs-target="#activityModal">
                                        <span><i class="ri-pencil-line"></i></span>
                                      </button>
                                    </div>
                                    <div class="delete" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('activity')">
                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                      </button>
                                    </div>
                                    <button type="button" (click)="createOpenActivityModal()" data-bs-toggle="modal" data-bs-target="#activityModal" class="btn btn-icon">
                                      <i class="ri-add-line"></i>
                                    </button>
                                </div>

                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData5"
                                    [columnDefs]="columnDefs5"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>

                            <div class="tab-pane fade" id="nav-projectSoftware" role="tabpanel">
                                <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                    <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" (click)="editOpenProjectSoftwareModal()" data-bs-toggle="modal" data-bs-target="#softwareModal">
                                        <span><i class="ri-pencil-line"></i></span>
                                      </button>
                                    </div>
                                    <div class="delete" *ngIf="selectedCheckboxData.length === 1">
                                      <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('software')">
                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                      </button>
                                    </div>
                                    <button type="button" (click)="createOpenProjectSoftwareModal()" data-bs-toggle="modal" data-bs-target="#softwareModal" class="btn btn-icon">
                                      <i class="ri-add-line"></i>
                                    </button>
                                </div>

                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData6"
                                    [columnDefs]="columnDefs6"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>

                            <div class="tab-pane fade" id="nav-task" role="tabpanel">
                                <div class="row align-items-center pt-3">
                                    <div class="col d-flex align-items-center">
                                        <form [formGroup]="taskFilterForm" class="d-flex align-items-center gap-2">
                                              <div class="input">
                                                <div class="input-item">
                                                    <select formControlName="activityId">
                                                        <option value="" disabled>Select Activity</option>
                                                        <option *ngFor="let activity of activityDropdown" value="{{activity}}">{{activity}}</option>
                                                    </select>
                                                    <label class="floating-label-special">Activity</label>
                                                    <i class="ri-shield-user-line"></i>
                                                </div>
                                              </div>
                                              <button class="btn" (click)="getTaskByActivity()">Submit</button>
                                        </form>
                                    </div>

                                    <div class="col-auto d-flex align-items-center gap-2 justify-content-end" *ngIf="this.isPMOAdmin || this.isPMOManager">
                                        <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                          <button type="button" (click)="editOpenTaskModal()" data-bs-toggle="modal" data-bs-target="#taskModal">
                                            <span><i class="ri-pencil-line"></i></span>
                                          </button>
                                        </div>
                                        <div class="delete" *ngIf="selectedCheckboxData.length === 1">
                                          <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal" (click)="deleteOpenModal('task')">
                                            <span><i class="ri-delete-bin-5-line"></i></span>
                                          </button>
                                        </div>
                                        <button type="button" (click)="createOpenTaskModal()" data-bs-toggle="modal" data-bs-target="#taskModal" class="btn btn-icon">
                                          <i class="ri-add-line"></i>
                                        </button>
                                    </div>
                                </div>
                                
                                <ag-grid-angular style="height: calc(100vh - 160px) !important;" 
                                    class="ag-theme-material"
                                    (gridReady)="onGridReady($event)"
                                    [rowData]="rowData7"
                                    [columnDefs]="columnDefs7"
                                    pagination="true"
                                    [defaultColDef]="defaultColDef"
                                    [suppressRowClickSelection]="true"
                                    [rowSelection]="rowSelection"
                                    (selectionChanged)="onSelectionChanged($event)"
                                    paginationPageSize=10>
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </article>
</main>
  
<!-- Delete an item -->
<div class="modal fade" id="deleteRiskModal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete {{ deleteType | titlecase }}?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDelete" type="button" class="btn btn-secondary"
                        data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0"
                        (click)="deleteConfirm()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Region Modal -->
<div class="modal fade bd-example-modal-lg" id="regionModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="regionForm">
                <div class="modal-header">
                    <h5 class="modal-title">Region</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="regionName" type="text">
                                        <label class="floating-label-special">Region</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalRegion" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createRegion()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateRegion()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Industry Modal -->
<div class="modal fade bd-example-modal-lg" id="industryModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="industryForm">
                <div class="modal-header">
                    <h5 class="modal-title">Industry</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="regionId">
                                            <option value="" disabled>Select Region</option>
                                            <option *ngFor="let region of regionDropdown" value="{{region}}">{{region}}</option>
                                        </select>
                                        <label class="floating-label-special">Region</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="industryName" type="text">
                                        <label class="floating-label-special">Industry</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalIndustry" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createIndustry()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateIndustry()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Business Group Modal -->
<div class="modal fade bd-example-modal-lg" id="businessGroupModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="businessGroupForm">
                <div class="modal-header">
                    <h5 class="modal-title">Business Group</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="regionId" (change)="getIndustryByRegion($event)">
                                            <option value="" disabled>Select Region</option>
                                            <option *ngFor="let region of regionDropdown" value="{{region}}">{{region}}</option>
                                        </select>
                                        <label class="floating-label-special">Region</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="industryId">
                                            <option value="" disabled>Select Industry</option>
                                            <option *ngFor="let industry of industryDropdown" value="{{industry}}">{{industry}}</option>
                                        </select>
                                        <label class="floating-label-special">Industry</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="businessGroupName" type="text">
                                        <label class="floating-label-special">Business Group</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalBusinessGroup" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createBusinessGroup()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateBusinessGroup()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Commodity Modal -->
<div class="modal fade bd-example-modal-lg" id="commodityModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="commodityForm">
                <div class="modal-header">
                    <h5 class="modal-title">Commodity</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="regionId" (change)="getIndustryByRegion($event)">
                                            <option value="" disabled>Select Region</option>
                                            <option *ngFor="let region of regionDropdown" value="{{region}}">{{region}}</option>
                                        </select>
                                        <label class="floating-label-special">Region</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="industryId" (change)="getBusinessGroupByIndustry($event)">
                                            <option value="" disabled>Select Industry</option>
                                            <option *ngFor="let industry of industryDropdown" value="{{industry}}">{{industry}}</option>
                                        </select>
                                        <label class="floating-label-special">Industry</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="businessGroupId">
                                            <option value="" disabled>Select Business Group</option>
                                            <option *ngFor="let bg of businessGroupDropdown" value="{{bg}}">{{bg}}</option>
                                        </select>
                                        <label class="floating-label-special">Business Group</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="commodityName" type="text">
                                        <label class="floating-label-special">Commodity</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalCommodity" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createCommodity()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateCommodity()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Activity Modal -->
<div class="modal fade bd-example-modal-lg" id="activityModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="activityForm">
                <div class="modal-header">
                    <h5 class="modal-title">Activity</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="activityName" type="text">
                                        <label class="floating-label-special">Activity</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalActivity" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createActivity()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateActivity()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Project Software Modal -->
<div class="modal fade bd-example-modal-lg" id="softwareModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="projectSoftwareForm">
                <div class="modal-header">
                    <h5 class="modal-title">Project Software</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="activityId">
                                            <option value="" disabled>Select Activity</option>
                                            <option *ngFor="let activity of activityDropdown" value="{{activity}}">{{activity}}</option>
                                        </select>
                                        <label class="floating-label-special">Activity</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="projectSoftwareName" type="text">
                                        <label class="floating-label-special">Project Software</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalSoftware" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createProjectSoftware()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateProjectSoftware()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Task Modal -->
<div class="modal fade bd-example-modal-lg" id="taskModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="taskForm">
                <div class="modal-header">
                    <h5 class="modal-title">Task</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <select formControlName="activityId">
                                            <option value="" disabled>Select Activity</option>
                                            <option *ngFor="let activity of activityDropdown" value="{{activity}}">{{activity}}</option>
                                        </select>
                                        <label class="floating-label-special">Activity</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="input">
                                    <div class="input-item">
                                        <input formControlName="taskDropdownName" type="text">
                                        <label class="floating-label-special">Task</label>
                                        <i class="ri-shield-user-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalTask" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createTask()">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateTask()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>